/**
 * Created by fan on 3/13/17.
 */
angular.module('smartorg.r6.cmpts.listSelector', []);
require('./list-selector-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.cmpts.listSelector';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/components/list-selector/app/js/plumbing/app.js